<template>
  <div class="home">
    <h1>I am the home component</h1>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h1, h2 {
  font-weight: normal;
  color: #42b983;
}
div .home{
  background-color: gray;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue